import { useState } from "react";
import { heroImage } from "../../../mocks/anime";

interface HeroProps {
  onSearch: (keyword: string) => void;
}

const quickTags = ["后宫", "逆后宫", "暧昧", "攻略", "高甜"];

export default function Hero({ onSearch }: HeroProps) {
  const [keyword, setKeyword] = useState("");

  const handleSearch = () => {
    onSearch(keyword.trim());
  };

  return (
    <section id="top" className="relative flex min-h-[640px] w-full items-center overflow-hidden">
      <img
        src={heroImage}
        alt="女神动漫后宫恋爱番推荐专区暖色视觉图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-4 py-24 text-center md:py-28">
        <span className="mx-auto mb-5 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-bold tracking-widest text-white backdrop-blur">
          <i className="ri-sparkling-2-fill text-amber-300"></i>
          后宫 · 恋爱 · 暧昧 · 攻略 · 逆后宫
        </span>

        <h1 className="font-display text-3xl leading-tight text-white md:text-5xl">
          女神动漫 · 后宫恋爱番推荐大全
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          精选高甜后宫、恋爱、暧昧与攻略题材佳作，支持标签快速筛选。
          想找女神动漫逆后宫或高甜攻略番，点开即可定位合口味的女神动漫恋爱故事，追更不再迷路。
        </p>

        <form
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <div className="flex flex-1 items-center gap-2 rounded-md bg-white px-4">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你想找的恋爱番，如「逆后宫」「高甜」"
              className="h-12 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-white/70">热门标签：</span>
          {quickTags.map((tag) => (
            <button
              key={tag}
              onClick={() => onSearch(tag)}
              className="whitespace-nowrap rounded-full border border-white/30 px-3.5 py-1.5 text-xs font-medium text-white transition-colors hover:border-primary-400 hover:bg-primary-500"
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mx-auto mt-12 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { num: "120+", label: "精选恋爱番" },
            { num: "5", label: "题材分类" },
            { num: "持续更新", label: "追番不迷路" },
          ].map((item) => (
            <div key={item.label} className="rounded-lg bg-white/10 px-3 py-4 backdrop-blur">
              <p className="font-display text-xl text-white md:text-2xl">{item.num}</p>
              <p className="mt-1 text-xs text-white/75">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}